import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore, isTokenValid } from "@/store";
import { ROUTES } from "@/lib/constants";

/** Redirects already-authenticated users away from guest-only pages (login, register). */
export function GuestGuard() {
  const { isAuthenticated, clearSession } = useAuthStore();

  // Only treat as authenticated if the stored JWT is actually still valid.
  // A stale persisted flag (token expired) must not block the login page.
  if (isAuthenticated && isTokenValid()) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  // Clear any stale session silently so the login form starts fresh
  if (isAuthenticated && !isTokenValid()) {
    clearSession();
  }

  return <Outlet />;
}
